import React, { useEffect, useCallback } from 'react';
import { getLanguage } from 'utils/language/language';
import config from 'utils/api/config';
import { env } from 'config/app.config';

interface ICountryMapProps {
	setData: (data: { [key: string]: string }) => void;
	setGis?: (data: string) => void;
	mainContainerRef?: React.RefObject<HTMLDivElement>;
	height?: string;
}

const CountryMap = (props: ICountryMapProps) => {
	const language = getLanguage();
	const handleEvent = useCallback(
		(e: any) => {
			const data = e.data.message?.split(',').reduce((acc: any, data: any) => {
				const [key, value] = data.split('=');
				return { ...acc, [key]: value === 'null' ? null : value };
			}, {});

			if (data) {
				props.setData(data);
				if (props.setGis) {
					props.setGis(e.data.message);
				}
				const current = props?.mainContainerRef?.current;
				if (current) {
					current.scrollTo({
						behavior: 'smooth',
						top: current.scrollHeight,
					});
				}
			}
		},
		[props]
	);

	useEffect(() => {
		if (typeof window.addEventListener != 'undefined') {
			window.addEventListener('message', handleEvent);
		}
		return () => {
			if (typeof window.addEventListener != 'undefined') {
				window.removeEventListener('onmessage', handleEvent);
			}
		};
	}, [handleEvent]);

	// for local development it will use other map
	const mapUrl =
		process.env.NODE_ENV === 'development'
			? 'https://testportal.omantel.om/wcm/connect/technical_en/static/map'
			: `https://portal.omantel.om/${
					language === 'en' ? 'customer_order_english' : 'customer_order_arabic'
			  }/?speed=null`;

	return (
		<div>
			<iframe
				title="country-map"
				id="countryMap"
				src={mapUrl}
				style={{ height: props.height ? props.height : '1033px', width: '100%', border: 'none' }}
			/>
		</div>
	);
};

export default CountryMap;
